window.ttx = window.ttx || {};
ttx.modal = {};

ttx.modal._instances = {};
ttx.modal._seed = 1;
// 记录本模块分配过的最高层级，保证后续弹窗（含嵌套在自身弹窗内的）始终更高
ttx.modal._maxZIndex = 1000;

ttx.modal._getTopZIndex = function () {
    // 查找页面上所有 modal/drawer 相关元素（含 Arco、ttx 自身与业务自定义弹窗），取最大 z-index
    var elements = document.querySelectorAll('[class*="modal"], [class*="Modal"], [class*="drawer"], [class*="Drawer"]');
    var maxZ = 1000;
    for (var i = 0; i < elements.length; i++) {
        var z = parseInt(elements[i].style.zIndex || window.getComputedStyle(elements[i]).zIndex || '0');
        if (z > maxZ) maxZ = z;
    }
    // ttx 自己的弹窗/抽屉遮罩无 class，靠内部计数器兜底
    if (ttx.modal._maxZIndex > maxZ) maxZ = ttx.modal._maxZIndex;
    // 确保比所有 Arco Modal 都高，再加 100 保险
    return maxZ + 100;
};

ttx.modal._defaultOptions = {
    title: '提示',
    content: '',
    width: 560,
    height: 'auto',
    bodyPadding: '20px',
    bodyMaxHeight: '70vh',
    showFooter: true,
    showWindowControls: false,
    draggable: false,
    closeOnMask: false,
    closeOnEsc: true,
    confirmText: '确定',
    cancelText: '取消',
    showCancel: false,
    autoZIndex: true,
    onConfirm: null,
    onCancel: null,
    onClose: null
};

ttx.modal._mergeOptions = function (options) {    
    return { ...ttx.modal._defaultOptions, ...(options || {}) };
};

ttx.modal._normalizeContent = function (content) {
    if (content instanceof HTMLElement) return content;
    if (typeof content === 'string') {
        const trimmed = content.trim();
        if (/^https?:\/\//i.test(trimmed)) {
            const iframe = document.createElement('iframe');
            iframe.src = trimmed;
            iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;';
            iframe.referrerPolicy = 'no-referrer-when-downgrade';
            return iframe;
        }
    }
    const text = document.createElement('div');
    text.style.cssText = 'white-space: pre-wrap;line-height:1.6;color:#333;';
    text.textContent = content == null ? '' : String(content);
    return text;
};

ttx.modal._removeInstance = function (id) {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete ttx.modal._instances[id];
};

ttx.modal._getAccentColor = function () {
    if (ttx.theme && typeof ttx.theme.getAccent === 'function') {
        return ttx.theme.getAccent() || '#165dff';
    }
    return '#165dff';
};

ttx.modal._create = function (options) {
    const opts = ttx.modal._mergeOptions(options);
        
    const id = 'tx-modal-' + ttx.modal._seed++;
    
    // 动态计算 z-index，确保比其他 modal 高
    let zIndex;
    if (opts.autoZIndex !== false) {
        zIndex = ttx.modal._getTopZIndex();
    } else {
        zIndex = opts.zIndex || 3000;
    }
    // 记录已分配的最高层级，后续嵌套弹窗在此基础上继续递增
    ttx.modal._maxZIndex = Math.max(ttx.modal._maxZIndex, zIndex);

    // 容器：优先使用调用方传入的 getPopupContainer，其次全局工具方法（当前 Pane 的 metaRunnerContainer），最后 body。
    // 挂载到非 body 容器（如 metaRunnerContainer，position:relative）时用 absolute 定位，弹窗只在当前 Pane 内，
    // 切换系统级页签时随 Pane 自动隐藏；仅当回落到 body 时才用 fixed 覆盖全视口。
    var customContainer = (typeof opts.getPopupContainer === 'function') ? opts.getPopupContainer() : null;
    var container = customContainer
        || (ttx.utils && typeof ttx.utils.getTopContainer === 'function'
            ? ttx.utils.getTopContainer()
            : null)
        || document.body;
    var useAbsolute = !!container && container !== document.body;

    const mask = document.createElement('div');
    mask.style.cssText = (useAbsolute ? 'position:absolute' : 'position:fixed') + ';top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.45);z-index:' + zIndex + ';display:flex;align-items:center;justify-content:center;';

    const panel = document.createElement('div');
    var maxW = useAbsolute ? 'calc(100% - 32px)' : 'calc(100vw - 32px)';
    var maxH = useAbsolute ? 'calc(100% - 32px)' : 'calc(100vh - 32px)';
    panel.style.cssText = `width:${typeof opts.width === 'number' ? opts.width + 'px' : opts.width};height:${typeof opts.height === 'number' ? opts.height + 'px' : opts.height};max-width:${maxW};max-height:${maxH};background:#fff;border-radius:4px;box-shadow:0 12px 36px rgba(0,0,0,.24);overflow:hidden;display:flex;flex-direction:column;`;

    const header = document.createElement('div');
    header.style.cssText = 'padding:14px 16px;font-size:14px;font-weight:400;border-bottom:1px solid #f0f0f0;cursor:' + (opts.draggable ? 'move' : 'default') + ';flex-shrink:0;display:flex;align-items:center;justify-content:space-between;gap:8px;';

    const titleEl = document.createElement('div');
    titleEl.textContent = opts.title || '提示';
    titleEl.style.cssText = 'min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
    header.appendChild(titleEl);

    let isExpanded = false;
    if (opts.showWindowControls) {
        const controls = document.createElement('div');
        controls.style.cssText = 'display:flex;align-items:center;gap:8px;flex-shrink:0;';

        const createIconBtn = function (label) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = label;
            btn.style.cssText = 'width:24px;height:24px;border:none;background:transparent;color:#666;cursor:pointer;border-radius:4px;display:flex;align-items:center;justify-content:center;font-size:14px;line-height:1;';
            btn.addEventListener('mouseenter', function () {
                btn.style.background = '#f5f5f5';
                btn.style.color = '#333';
            });
            btn.addEventListener('mouseleave', function () {
                btn.style.background = 'transparent';
                btn.style.color = '#666';
            });
            return btn;
        };

        const zoomBtn = createIconBtn('□');
        const closeTopBtn = createIconBtn('✕');

        zoomBtn.addEventListener('pointerdown', function (e) {
            e.stopPropagation();
        });
        closeTopBtn.addEventListener('pointerdown', function (e) {
            e.stopPropagation();
        });

        zoomBtn.addEventListener('click', function () {
            isExpanded = !isExpanded;
            if (isExpanded) {
                panel.style.width = useAbsolute ? 'calc(100% - 16px)' : 'calc(100vw - 16px)';
                panel.style.height = useAbsolute ? 'calc(100% - 16px)' : 'calc(100vh - 16px)';
                zoomBtn.textContent = '❐';
            } else {
                panel.style.width = typeof opts.width === 'number' ? opts.width + 'px' : opts.width;
                panel.style.height = typeof opts.height === 'number' ? opts.height + 'px' : opts.height;
                zoomBtn.textContent = '□';
            }
        });

        closeTopBtn.addEventListener('click', function () {
            close('header-close');
        });

        controls.appendChild(zoomBtn);
        controls.appendChild(closeTopBtn);
        header.appendChild(controls);
    }

    const body = document.createElement('div');
    body.style.cssText = `padding:${opts.bodyPadding};max-height:${opts.bodyMaxHeight};overflow:auto;flex:1;min-height:0;`;
    body.appendChild(ttx.modal._normalizeContent(opts.content));

    const footer = document.createElement('div');
    footer.style.cssText = 'padding:12px 16px;border-top:1px solid #f0f0f0;display:flex;justify-content:flex-end;gap:8px;flex-shrink:0;';

    const createButton = function (text, primary) {
        const btn = document.createElement('button');
        const accentColor = ttx.modal._getAccentColor();
        btn.type = 'button';
        btn.textContent = text;
        btn.style.cssText = primary
            ? 'height:32px;padding:0 14px;border:1px solid ' + accentColor + ';background:' + accentColor + ';color:#fff;border-radius:4px;cursor:pointer;'
            : 'height:32px;padding:0 14px;border:1px solid #d9d9d9;background:#fff;color:#333;border-radius:4px;cursor:pointer;';
        return btn;
    };

    const confirmBtn = createButton(opts.confirmText, true);
    confirmBtn.setAttribute('data-tx-modal-confirm', '');
    const cancelBtn = createButton(opts.cancelText, false);

    // 如果禁用自动聚焦按钮，则设置 tabindex 为 -1 防止浏览器默认聚焦
    if (opts.autoFocusBtn === false) {
        confirmBtn.setAttribute('tabindex', '-1');
        cancelBtn.setAttribute('tabindex', '-1');
    }

    if (opts.showCancel) {
        footer.appendChild(cancelBtn);
    }
    footer.appendChild(confirmBtn);

    panel.appendChild(header);
    panel.appendChild(body);
    if (opts.showFooter) {
        panel.appendChild(footer);
    }
    mask.appendChild(panel);
    if (container) {
        container.appendChild(mask);
    }
    
    // 自动聚焦到第一个可聚焦元素（支持多个 Modal 叠加）
    setTimeout(function () {
        var focusableSelector = 'input, [contenteditable], textarea, select, button, [href], [tabindex]:not([tabindex="-1"])';
        var focusableElements = panel.querySelectorAll(focusableSelector);
        if (focusableElements.length > 0) {
            var targetElement = focusableElements[0];
            // 如果有 input，优先聚焦到 input
            for (var i = 0; i < focusableElements.length; i++) {
                if (focusableElements[i].tagName === 'INPUT' || focusableElements[i].tagName === 'TEXTAREA') {
                    targetElement = focusableElements[i];
                    break;
                }
            }
            targetElement.focus();
        } else {
            // 如果没有可聚焦元素，给 panel 添加 tabindex 并聚焦
            panel.setAttribute('tabindex', '-1');
            panel.focus();
        }
    }, 100);

    let dragging = false;
    let startX = 0;
    let startY = 0;
    let startL = 0;
    let startT = 0;

    const onPointerDown = function (e) {
        if (!opts.draggable) return;
        dragging = true;
        const rect = panel.getBoundingClientRect();
        startX = e.clientX;
        startY = e.clientY;
        startL = rect.left;
        startT = rect.top;
        panel.style.position = 'fixed';
        panel.style.margin = '0';
        panel.style.left = startL + 'px';
        panel.style.top = startT + 'px';
        header.style.cursor = 'grabbing';
    };

    const onPointerMove = function (e) {
        if (!dragging) return;
        const nextL = startL + (e.clientX - startX);
        const nextT = startT + (e.clientY - startY);
        const maxL = Math.max(0, window.innerWidth - panel.offsetWidth);
        const maxT = Math.max(0, window.innerHeight - panel.offsetHeight);
        panel.style.left = Math.min(Math.max(0, nextL), maxL) + 'px';
        panel.style.top = Math.min(Math.max(0, nextT), maxT) + 'px';
    };

    const onPointerUp = function () {
        if (!dragging) return;
        dragging = false;
        header.style.cursor = opts.draggable ? 'move' : 'default';
    };

    if (opts.draggable) {
        header.addEventListener('pointerdown', onPointerDown);
        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
    }

    let closed = false;
    const close = function (trigger) {
        if (closed) return;
        closed = true;
        if (mask.parentNode) {
            mask.parentNode.removeChild(mask);
        }
        if (opts.draggable) {
            header.removeEventListener('pointerdown', onPointerDown);
            window.removeEventListener('pointermove', onPointerMove);
            window.removeEventListener('pointerup', onPointerUp);
        }
        document.removeEventListener('keydown', onKeydown);
        ttx.modal._removeInstance(id);
        if (typeof opts.onClose === 'function') {
            opts.onClose(trigger);
        }
    };

    const onKeydown = function (e) {
        if (opts.closeOnEsc && e.key === 'Escape') {
            if (opts.showCancel && typeof opts.onCancel === 'function') {
                opts.onCancel();
            }
            close('esc');
            return;
        }
        
        // 焦点陷阱：捕获 Tab 键，防止焦点逃离 modal
        if (e.key === 'Tab') {
            var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            var focusableElements = panel.querySelectorAll(focusableSelector);
            if (focusableElements.length === 0) return;
            
            var firstElement = focusableElements[0];
            var lastElement = focusableElements[focusableElements.length - 1];
            
            if (e.shiftKey) {
                // Shift + Tab：如果在第一个元素，跳到最后一个
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else {
                // Tab：如果在最后一个元素，跳到第一个
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }
    };

    if (opts.closeOnMask) {
        mask.addEventListener('click', function (e) {
            if (e.target === mask) {
                if (opts.showCancel && typeof opts.onCancel === 'function') {
                    opts.onCancel();
                }
                close('mask');
            }
        });
    }

    confirmBtn.addEventListener('click', function () {
        if (typeof opts.onConfirm === 'function') {
            opts.onConfirm();
        }
        close('confirm');
    });

    cancelBtn.addEventListener('click', function () {
        if (typeof opts.onCancel === 'function') {
            opts.onCancel();
        }
        close('cancel');
    });

    document.addEventListener('keydown', onKeydown);

    const instance = {
        id,
        close,
        update: function (next) {
            const nextOptions = next || {};
            if (nextOptions.title != null) {
                titleEl.textContent = String(nextOptions.title);
            }
            if (nextOptions.content !== undefined) {
                body.innerHTML = '';
                body.appendChild(ttx.modal._normalizeContent(nextOptions.content));
            }
        }
    };

    ttx.modal._instances[id] = instance;
    return instance;
};

ttx.modal.config = function (options) {
    if (!options) return;
    Object.assign(ttx.modal._defaultOptions, options);
};

ttx.modal.open = function (options) {
    // 兼容 MDF：extraConfig._innerType === 'fadeRightToLeft' 时自动走侧滑抽屉流程
    if (options && options.extraConfig && options.extraConfig._innerType === 'fadeRightToLeft') {
        return ttx.modal.openDrawer(options);
    }
    return ttx.modal._create(options);
};

// 打开大尺寸弹框（90% * 90%）
ttx.modal.launch = function (options) {
    return ttx.modal._create({
        ...(options || {}),
        width: '90vw',
        height: '90vh',
        bodyPadding: '0',
        bodyMaxHeight: 'none',
        showFooter: false,
        showWindowControls: true,
        draggable: true
    });
};

/**
 * 判断是否为错误对象新规范（含 displayCode/detailMsg/level 等字段）
 * @param {any} obj
 * @returns {boolean}
 */
ttx.modal._isErrorObj = function (obj) {
    return obj && typeof obj === 'object' && (obj.displayCode || obj.detailMsg || obj.level !== undefined);
};

ttx.modal.alert = function (content, options) {
    // 兼容错误对象新规范：第一个参数为错误对象时自动走错误详情流程
    if (ttx.modal._isErrorObj(content)) {
        var errOpts = options || {};
        if (content.complexType === true && typeof ttx.modal.showComplexError === 'function') {
            return ttx.modal.showComplexError(content);
        }
        if (typeof ttx.modal.showErrorDetail === 'function') {
            return ttx.modal.showErrorDetail(content, errOpts);
        }
    }
    const custom = options || {};
    return new Promise(function (resolve) {
        ttx.modal._create({
            ...custom,
            content,
            showCancel: false,
            onConfirm: function () {
                if (typeof custom.onConfirm === 'function') custom.onConfirm();
                resolve(true);
            },
            onClose: function (trigger) {
                if (trigger !== 'confirm') resolve(false);
                if (typeof custom.onClose === 'function') custom.onClose(trigger);
            }
        });
    });
};

ttx.modal.confirm = function (options) {
    const custom = options || {};
    return new Promise(function (resolve) {
        ttx.modal._create({
            ...custom,
            // content,
            showCancel: true,
            onConfirm: function () {
                if (typeof custom.onConfirm === 'function') custom.onConfirm();
                resolve(true);
            },
            onCancel: function () {
                if (typeof custom.onCancel === 'function') custom.onCancel();
                resolve(false);
            },
            onClose: function (trigger) {
                if (trigger !== 'confirm' && trigger !== 'cancel') resolve(false);
                if (typeof custom.onClose === 'function') custom.onClose(trigger);
            }
        });
    });
};

/**
 * 输入弹窗 — 类似 confirm 但带文本输入框
 *
 * options:
 *   title         — 标题（默认 '请输入'）
 *   placeholder   — 输入框占位符（默认 '请输入内容'）
 *   defaultValue  — 输入框默认值
 *   confirmText   — 确认按钮文字（默认 '确定'）
 *   cancelText    — 取消按钮文字（默认 '取消'）
 *
 * 返回 Promise<string|null>：确定返回输入值，取消/关闭返回 null
 */
ttx.modal.prompt = function (options) {
    var custom = options || {};
    var title = custom.title || '请输入';
    var placeholder = custom.placeholder || '请输入内容';
    var defaultValue = custom.defaultValue || '';

    return new Promise(function (resolve) {
        // 构建带输入框的内容 DOM
        var wrapper = document.createElement('div');
        wrapper.style.cssText = 'padding:0;';

        if (custom.message) {
            var msg = document.createElement('div');
            msg.style.cssText = 'margin-bottom:12px;color:#333;line-height:1.6;white-space:pre-wrap;';
            msg.textContent = custom.message;
            wrapper.appendChild(msg);
        }

        var input = document.createElement('input');
        input.type = 'text';
        input.value = defaultValue;
        input.placeholder = placeholder;
        input.style.cssText = 'width:100%;height:32px;padding:0 8px;border:1px solid #d9d9d9;border-radius:4px;font-size:14px;outline:none;box-sizing:border-box;';
        input.addEventListener('focus', function () { input.style.borderColor = ttx.modal._getAccentColor(); });
        input.addEventListener('blur', function () { input.style.borderColor = '#d9d9d9'; });
        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                // 找到当前弹窗的确认按钮并点击
                var btns = document.querySelectorAll('[data-tx-modal-confirm]');
                if (btns.length) btns[btns.length - 1].click();
            }
        });
        wrapper.appendChild(input);

        var instance = ttx.modal._create({
            ...custom,
            title: title,
            content: wrapper,
            showCancel: true,
            showFooter: true,
            autoFocusBtn: false,
            confirmText: custom.confirmText || '确定',
            cancelText: custom.cancelText || '取消',
            onConfirm: function () {
                var val = (input.value || '').trim();
                if (typeof custom.onConfirm === 'function') custom.onConfirm(val);
                resolve(val || null);
            },
            onCancel: function () {
                if (typeof custom.onCancel === 'function') custom.onCancel();
                resolve(null);
            },
            onClose: function (trigger) {
                if (trigger !== 'confirm' && trigger !== 'cancel') resolve(null);
                if (typeof custom.onClose === 'function') custom.onClose(trigger);
            }
        });

        // 自动聚焦输入框（使用多个延迟确保在各种情况下都能聚焦）
        var focusInput = function () {
            input.focus();
            if (input.value) {
                input.select();
            }
        };
        setTimeout(focusInput, 50);
        setTimeout(focusInput, 150);
        setTimeout(focusInput, 300);
    });
};

ttx.modal.close = function (id) {
    if (!id || !ttx.modal._instances[id]) return;
    ttx.modal._instances[id].close();
};

ttx.modal.closeAll = function () {
    Object.keys(ttx.modal._instances).forEach(function (id) {
        ttx.modal._instances[id].close();
    });
};

// ============================================================
// 侧滑抽屉（Drawer）
// 纯 DOM 实现，与现有 modal 风格保持一致
// ============================================================

// 抽屉实例注册表：id -> { id, close, update }
ttx.modal._drawerRegistry = {};
// 抽屉自增 id
ttx.modal._drawerSeed = 1;

// 抽屉默认配置（继承自 modal 默认配置，额外补充抽屉特有字段）
ttx.modal._drawerDefaultOptions = {
    title: '提示',
    content: '',
    width: 500,
    placement: 'right',     // 'right' | 'left'
    mask: true,             // 是否显示遮罩
    maskClosable: true,     // 点击遮罩是否关闭
    closeOnEsc: true,
    showFooter: false,
    bodyPadding: '20px',
    confirmText: '确定',
    cancelText: '取消',
    showCancel: false,
    zIndex: 3000,
    onConfirm: null,
    onCancel: null,
    onClose: null
};

/**
 * 创建侧滑抽屉实例（内部方法）
 * @param {object} options 抽屉配置
 * @returns {object} 抽屉实例 { id, close, update }
 */
ttx.modal._createDrawer = function (options) {
    var opts = Object.assign({}, ttx.modal._drawerDefaultOptions, ttx.modal._defaultOptions, options || {});
    var id = 'tx-drawer-' + ttx.modal._drawerSeed++;

    // 动态计算层级，保证嵌套抽屉/弹窗时不被盖住
    var baseZ = opts.autoZIndex !== false ? ttx.modal._getTopZIndex() : (opts.zIndex || 3000);
    ttx.modal._maxZIndex = Math.max(ttx.modal._maxZIndex, baseZ + 1);

    // 容器与定位：挂载到当前 Pane 的 metaRunnerContainer（position:relative）时用 absolute，回落到 body 时用 fixed。
    var container = ttx.utils && typeof ttx.utils.getTopContainer === 'function'
        ? ttx.utils.getTopContainer()
        : null;
    container = container || document.body;
    var useAbsolute = container !== document.body;
    var pos = useAbsolute ? 'absolute' : 'fixed';
    var maxWidth = useAbsolute ? '100%' : '100vw';

    // 遮罩层
    var mask = document.createElement('div');
    mask.style.cssText = 'position:' + pos + ';inset:0;background:rgba(0,0,0,.45);z-index:' + baseZ + ';';

    // 抽屉面板
    var panel = document.createElement('div');
    var widthStr = typeof opts.width === 'number' ? opts.width + 'px' : opts.width;
    var placement = opts.placement === 'left' ? 'left' : 'right';
    panel.style.cssText =
        'position:' + pos + ';top:0;bottom:0;' + placement + ':0;' +
        'width:' + widthStr + ';max-width:' + maxWidth + ';background:#fff;box-shadow:0 12px 36px rgba(0,0,0,.24);' +
        'z-index:' + (baseZ + 1) + ';display:flex;flex-direction:column;overflow:hidden;' +
        'animation:tx-drawer-slide-' + placement + ' 0.3s ease-out;';

    // 标题栏
    var header = document.createElement('div');
    header.style.cssText = 'padding:14px 16px;font-size:14px;font-weight:400;border-bottom:1px solid #f0f0f0;flex-shrink:0;display:flex;align-items:center;justify-content:space-between;gap:8px;';
    var titleEl = document.createElement('div');
    titleEl.textContent = opts.title || '提示';
    titleEl.style.cssText = 'min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
    header.appendChild(titleEl);

    var closeTopBtn = document.createElement('button');
    closeTopBtn.type = 'button';
    closeTopBtn.innerHTML = '✕';
    closeTopBtn.style.cssText = 'width:24px;height:24px;border:none;background:transparent;color:#666;cursor:pointer;border-radius:4px;display:flex;align-items:center;justify-content:center;font-size:14px;line-height:1;flex-shrink:0;';
    closeTopBtn.addEventListener('mouseenter', function () {
        closeTopBtn.style.background = '#f5f5f5';
        closeTopBtn.style.color = '#333';
    });
    closeTopBtn.addEventListener('mouseleave', function () {
        closeTopBtn.style.background = 'transparent';
        closeTopBtn.style.color = '#666';
    });
    closeTopBtn.addEventListener('click', function () {
        close('header-close');
    });
    header.appendChild(closeTopBtn);

    // 内容区
    var body = document.createElement('div');
    body.style.cssText = 'padding:' + opts.bodyPadding + ';overflow:auto;flex:1;min-height:0;';
    body.appendChild(ttx.modal._normalizeContent(opts.content));

    panel.appendChild(header);
    panel.appendChild(body);

    // 底部按钮区（可选）
    var footer = null;
    if (opts.showFooter) {
        footer = document.createElement('div');
        footer.style.cssText = 'padding:12px 16px;border-top:1px solid #f0f0f0;display:flex;justify-content:flex-end;gap:8px;flex-shrink:0;';
        var createButton = function (text, primary) {
            var btn = document.createElement('button');
            var accentColor = ttx.modal._getAccentColor();
            btn.type = 'button';
            btn.textContent = text;
            btn.style.cssText = primary
                ? 'height:32px;padding:0 14px;border:1px solid ' + accentColor + ';background:' + accentColor + ';color:#fff;border-radius:4px;cursor:pointer;'
                : 'height:32px;padding:0 14px;border:1px solid #d9d9d9;background:#fff;color:#333;border-radius:4px;cursor:pointer;';
            return btn;
        };
        var confirmBtn = createButton(opts.confirmText, true);
        var cancelBtn = createButton(opts.cancelText, false);
        if (opts.showCancel) {
            footer.appendChild(cancelBtn);
        }
        footer.appendChild(confirmBtn);
        panel.appendChild(footer);

        confirmBtn.addEventListener('click', function () {
            if (typeof opts.onConfirm === 'function') opts.onConfirm();
            close('confirm');
        });
        cancelBtn.addEventListener('click', function () {
            if (typeof opts.onCancel === 'function') opts.onCancel();
            close('cancel');
        });
    }

    if (opts.mask) {
        container.appendChild(mask);
    }
    container.appendChild(panel);

    // 关闭逻辑
    var closed = false;
    var close = function (trigger) {
        if (closed) return;
        closed = true;

        // 侧滑退出动画
        if (placement === 'left') {
            panel.style.animation = 'tx-drawer-slideout-left 0.25s ease-in forwards';
        } else {
            panel.style.animation = 'tx-drawer-slideout-right 0.25s ease-in forwards';
        }
        mask.style.transition = 'opacity 0.25s ease-in';
        mask.style.opacity = '0';

        setTimeout(function () {
            if (panel.parentNode) panel.parentNode.removeChild(panel);
            if (mask.parentNode) mask.parentNode.removeChild(mask);
        }, 260);

        document.removeEventListener('keydown', onKeydown);
        ttx.modal._removeDrawer(id);
        if (typeof opts.onClose === 'function') {
            opts.onClose(trigger);
        }
    };

    // 点击遮罩关闭
    if (opts.mask && opts.maskClosable) {
        mask.addEventListener('click', function () {
            close('mask');
        });
    }

    // ESC 关闭
    var onKeydown = function (e) {
        if (opts.closeOnEsc && e.key === 'Escape') {
            close('esc');
        }
    };
    if (opts.closeOnEsc) {
        document.addEventListener('keydown', onKeydown);
    }

    var instance = {
        id: id,
        close: close,
        update: function (next) {
            var nextOptions = next || {};
            if (nextOptions.title != null) {
                titleEl.textContent = String(nextOptions.title);
            }
            if (nextOptions.content !== undefined) {
                body.innerHTML = '';
                body.appendChild(ttx.modal._normalizeContent(nextOptions.content));
            }
        }
    };

    ttx.modal._drawerRegistry[id] = instance;
    return instance;
};

ttx.modal._removeDrawer = function (id) {
    delete ttx.modal._drawerRegistry[id];
};

/**
 * 打开侧滑抽屉（从右滑入）
 * options 继承 ttx.modal.open 的所有参数，额外支持：
 *   - title        抽屉标题
 *   - width        抽屉宽度（数字 px 或字符串 '30%'，默认 500）
 *   - placement    'right'（默认）/ 'left'
 *   - mask         是否显示遮罩（默认 true）
 *   - maskClosable 点击遮罩是否关闭（默认 true）
 *   - onClose      关闭回调
 *   - content      React 元素或渲染函数 / HTMLElement / 字符串
 *   - extraConfig  兼容 MDF，支持 _innerType='fadeRightToLeft'
 * 返回 Promise（关闭时 resolve，resolve 值为关闭 trigger）
 */
ttx.modal.openDrawer = function (options) {
    var custom = options || {};
    var drawerInstance = null;
    var promise = new Promise(function (resolve) {
        drawerInstance = ttx.modal._createDrawer(Object.assign({}, custom, {
            onClose: function (trigger) {
                resolve(trigger);
                if (typeof custom.onClose === 'function') custom.onClose(trigger);
            }
        }));
    });
    // 将实例 id 挂到 promise 上，便于外部通过 closeDrawer 关闭
    promise.__drawerId = drawerInstance ? drawerInstance.id : null;
    promise.close = function () {
        if (drawerInstance) drawerInstance.close();
    };
    return promise;
};

/**
 * 关闭指定抽屉
 * @param {string} id 抽屉实例 id
 */
ttx.modal.closeDrawer = function (id) {
    if (!id || !ttx.modal._drawerRegistry[id]) return;
    ttx.modal._drawerRegistry[id].close();
};

// 注入抽屉侧滑动画样式（仅注入一次）
if (typeof document !== 'undefined' && !document.getElementById('tx-drawer-style')) {
    var drawerStyle = document.createElement('style');
    drawerStyle.id = 'tx-drawer-style';
    drawerStyle.textContent =
        '@keyframes tx-drawer-slide-right {' +
        '  from { transform: translateX(100%); }' +
        '  to { transform: translateX(0); }' +
        '}' +
        '@keyframes tx-drawer-slide-left {' +
        '  from { transform: translateX(-100%); }' +
        '  to { transform: translateX(0); }' +
        '}' +
        '@keyframes tx-drawer-slideout-right {' +
        '  from { transform: translateX(0); }' +
        '  to { transform: translateX(100%); }' +
        '}' +
        '@keyframes tx-drawer-slideout-left {' +
        '  from { transform: translateX(0); }' +
        '  to { transform: translateX(-100%); }' +
        '}';
    document.head.appendChild(drawerStyle);
}

// ============================================================
// 错误对象新规范（MDF 错误对象）
// 字段：displayCode / detailMsg / showDetail / level / traceId / uploadable / errorDetail / complexType
// ============================================================

/**
 * 构造错误详情展示内容 DOM
 * @param {object} errorObj 错误对象
 * @returns {HTMLDivElement}
 */
ttx.modal._buildErrorDetailContent = function (errorObj) {
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'padding:0;font-size:13px;color:#333;line-height:1.6;';

    var addRow = function (label, value) {
        if (value === undefined || value === null || value === '') return;
        var row = document.createElement('div');
        row.style.cssText = 'display:flex;padding:8px 0;border-bottom:1px dashed #f0f0f0;';
        var labelEl = document.createElement('span');
        labelEl.style.cssText = 'width:90px;color:#999;flex-shrink:0;';
        labelEl.textContent = label;
        var valueEl = document.createElement('span');
        valueEl.style.cssText = 'flex:1;word-break:break-all;white-space:pre-wrap;min-width:0;';
        valueEl.textContent = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
        row.appendChild(labelEl);
        row.appendChild(valueEl);
        wrapper.appendChild(row);
    };

    addRow('展示码', errorObj.displayCode || errorObj.code);
    addRow('详细信息', errorObj.detailMsg || errorObj.message);
    addRow('追踪ID', errorObj.traceId);
    if (errorObj.errorDetail) {
        addRow('错误详情', errorObj.errorDetail);
    }
    return wrapper;
};

/**
 * 显示错误详情弹窗
 * 展示 displayCode、detailMsg、traceId、errorDetail；
 * 如果 errorObj.uploadable 为 true，显示"上传日志"按钮
 * @param {object} errorObj 错误对象
 * @param {object} [options] 额外配置 { onClose }
 * @returns {Promise<boolean>} 确认/上传返回 true，关闭返回 false
 */
ttx.modal.showErrorDetail = function (errorObj, options) {
    if (!errorObj) return Promise.resolve(false);
    var custom = options || {};
    var content = ttx.modal._buildErrorDetailContent(errorObj);
    var uploadable = !!errorObj.uploadable;

    return new Promise(function (resolve) {
        ttx.modal._create({
            title: '错误详情',
            content: content,
            width: 560,
            showCancel: uploadable,
            confirmText: uploadable ? '上传日志' : '确定',
            cancelText: '关闭',
            onConfirm: function () {
                // 上传日志：优先调用错误对象上的 onUpload
                if (uploadable && typeof errorObj.onUpload === 'function') {
                    try { errorObj.onUpload(); } catch (e) {}
                }
                resolve(true);
            },
            onClose: function (trigger) {
                if (trigger !== 'confirm') resolve(false);
                if (typeof custom.onClose === 'function') custom.onClose(trigger);
            }
        });
    });
};

/**
 * 显示复杂错误弹窗（保存校验错误，complexType === true 时使用）
 * 左侧面板：错误列表；右侧小弹窗：错误详情
 * @param {object} errorObj 错误对象，errors/errorDetail 为错误数组
 * @param {object} [options] 额外配置 { onClose }
 * @returns {Promise<boolean>}
 */
ttx.modal.showComplexError = function (errorObj, options) {
    if (!errorObj) return Promise.resolve(false);
    var custom = options || {};

    // 错误列表：优先 errors，其次 errorDetail（数组）
    var errors = [];
    if (Array.isArray(errorObj.errors)) {
        errors = errorObj.errors;
    } else if (Array.isArray(errorObj.errorDetail)) {
        errors = errorObj.errorDetail;
    } else if (errorObj.errorDetail) {
        errors = [errorObj.errorDetail];
    }
    if (!errors.length) {
        // 无列表数据时退化为普通错误详情
        return ttx.modal.showErrorDetail(errorObj, custom);
    }

    // 容器：左侧列表 + 右侧详情
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;height:50vh;min-height:300px;';

    // 左侧错误列表
    var leftPanel = document.createElement('div');
    leftPanel.style.cssText = 'width:260px;border-right:1px solid #f0f0f0;overflow:auto;flex-shrink:0;';
    var list = document.createElement('div');
    list.style.cssText = 'padding:4px 0;';
    leftPanel.appendChild(list);

    // 右侧详情面板（小弹窗）
    var rightPanel = document.createElement('div');
    rightPanel.style.cssText = 'flex:1;padding:12px 16px;overflow:auto;min-width:0;';
    var detailHolder = document.createElement('div');
    rightPanel.appendChild(detailHolder);

    wrapper.appendChild(leftPanel);
    wrapper.appendChild(rightPanel);

    // 渲染右侧详情
    var renderDetail = function (item) {
        detailHolder.innerHTML = '';
        if (!item) {
            var tip = document.createElement('div');
            tip.style.cssText = 'color:#999;font-size:13px;';
            tip.textContent = '请点击左侧错误项查看详情';
            detailHolder.appendChild(tip);
            return;
        }
        var sub = ttx.modal._buildErrorDetailContent(item);
        detailHolder.appendChild(sub);
    };

    // 渲染左侧列表项
    errors.forEach(function (item, idx) {
        var row = document.createElement('div');
        row.style.cssText = 'padding:8px 12px;cursor:pointer;border-bottom:1px solid #fafafa;font-size:13px;color:#333;display:flex;align-items:center;gap:6px;';
        var dot = document.createElement('span');
        dot.style.cssText = 'width:6px;height:6px;border-radius:50%;background:#ff4d4f;flex-shrink:0;';
        var text = document.createElement('span');
        text.style.cssText = 'flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;';
        text.textContent = (item && (item.displayCode || item.detailMsg || item.message)) || ('错误 ' + (idx + 1));
        row.appendChild(dot);
        row.appendChild(text);

        row.addEventListener('mouseenter', function () {
            if (row.dataset.active !== '1') row.style.background = '#f5f5f5';
        });
        row.addEventListener('mouseleave', function () {
            if (row.dataset.active !== '1') row.style.background = 'transparent';
        });
        row.addEventListener('click', function () {
            // 切换选中态
            var prev = list.querySelector('[data-active="1"]');
            if (prev) {
                prev.dataset.active = '0';
                prev.style.background = 'transparent';
            }
            row.dataset.active = '1';
            row.style.background = '#e8f3ff';
            renderDetail(item);
        });
        list.appendChild(row);
    });

    // 默认选中第一项
    var firstRow = list.firstElementChild;
    if (firstRow) {
        firstRow.click();
    } else {
        renderDetail(null);
    }

    return new Promise(function (resolve) {
        ttx.modal._create({
            title: errorObj.displayCode || '错误详情',
            content: wrapper,
            width: 720,
            showCancel: false,
            confirmText: '确定',
            onConfirm: function () {
                resolve(true);
            },
            onClose: function (trigger) {
                if (trigger !== 'confirm') resolve(false);
                if (typeof custom.onClose === 'function') custom.onClose(trigger);
            }
        });
    });
};

// ============================================================
// MDF communication API（弹窗通信统一入口）
// ============================================================

/**
 * MDF 通信统一入口
 * 对应 MDF cb.modal.communication
 *
 * options:
 *   type: 'return'（关闭弹窗/返回）/ 'modal'（打开弹窗）/ 'platform'（打开自定义页面）
 *   payload: { key, mode, groupCode, data, viewModel, url, type }
 *
 * 分支说明：
 *   - type='return' → 关闭当前 modal（调用 closeAll）
 *   - type='modal' + payload.key → 打开自定义组件弹窗（复用 open）
 *   - type='modal' + payload.mode='inner' + payload.groupCode → 弹出页面区域
 *   - type='modal' + payload.mode='html' → HTML 片段弹窗
 *   - type='modal' + payload.type='platform' → 打开自定义路由
 *   - type='modal' + payload.type='iframe' → iframe 弹窗
 *
 * 监听弹窗按钮事件说明（不强制实现，由调用方自行通过 on/execute 监听）：
 *   - UI 模板配置按钮：监听对应 action 的 before/after 前后置事件
 *   - 框架默认按钮：afterOkClick（确定）、beforeClose/afterClose（取消）
 *
 * @param {object} options 通信配置
 * @returns {object|undefined} 弹窗实例（打开弹窗时返回）
 */
ttx.modal.communication = function (options) {
    var opts = options || {};
    var type = opts.type;
    var payload = opts.payload || {};

    // type='return'：关闭当前弹窗/返回
    if (type === 'return') {
        ttx.modal.closeAll();
        return;
    }

    // type='platform'：打开自定义页面（委托 portal）
    if (type === 'platform') {
        if (ttx.portal && typeof ttx.portal.open === 'function') {
            ttx.portal.open(payload);
        } else {
            ttx.console.warn('[ttx.modal.communication] platform 模式需 ttx.portal 支持');
        }
        return;
    }

    // type='modal'：打开弹窗
    if (type === 'modal') {
        // payload.type='platform'：打开自定义路由
        if (payload.type === 'platform') {
            if (ttx.portal && typeof ttx.portal.open === 'function') {
                ttx.portal.open(payload);
            } else {
                ttx.console.warn('[ttx.modal.communication] modal.platform 需 ttx.portal 支持');
            }
            return;
        }

        // payload.type='iframe'：iframe 弹窗
        if (payload.type === 'iframe') {
            var url = payload.url || payload.data;
            return ttx.modal.open({
                title: payload.title || '页面',
                content: url,
                width: payload.width || '90vw',
                height: payload.height || '90vh',
                showFooter: false,
                showWindowControls: true
            });
        }

        // payload.mode='html'：HTML 片段弹窗
        if (payload.mode === 'html') {
            return ttx.modal.open({
                title: payload.title || '提示',
                content: payload.data || payload.html || '',
                width: payload.width || 560,
                showFooter: false
            });
        }

        // payload.mode='inner' + payload.groupCode：弹出页面区域
        if (payload.mode === 'inner' && payload.groupCode) {
            // 页面区域弹窗：以 groupCode 作为标识，content 取 payload.data
            return ttx.modal.open({
                title: payload.title || payload.groupCode,
                content: payload.data || '',
                width: payload.width || 560,
                showFooter: false
            });
        }

        // payload.key：打开自定义组件弹窗（复用 open）
        if (payload.key) {
            return ttx.modal.open({
                title: payload.title || payload.key,
                content: payload.data || payload.content || '',
                width: payload.width || 560,
                showFooter: payload.showFooter !== false,
                extraConfig: payload.extraConfig
            });
        }

        ttx.console.warn('[ttx.modal.communication] modal 模式缺少 payload.key/mode/type');
        return;
    }

    ttx.console.warn('[ttx.modal.communication] 不支持的 type: ' + type);
};

/**
 * 打开弹窗别名，封装 communication({type:'modal', payload:options})
 * 对应 MDF cb.modal.openModal
 * @param {object} options 弹窗配置（作为 communication 的 payload）
 * @returns {object|undefined} 弹窗实例
 */
ttx.modal.openModal = function (options) {
    return ttx.modal.communication({ type: 'modal', payload: options || {} });
};